import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';

import CTATooltip from 'buyside/components/presentation/AccessControl/ctaTooltip';

import styles from './redactedStyles.scss';

const RedactedDataPoint: React.FC<{
  Wrapper: 'span' | 'div';
  overlayLeft?: string;
  blurLeft?: string;
}> = ({ blurLeft, overlayLeft, Wrapper }) => {
  return (
    <CTATooltip>
      <Wrapper className={styles.overlay} style={{ '--overlayLeft': `${overlayLeft || '15px'}` }}>
        <FontAwesomeIcon icon={faLock} className={styles.lockIcon} />
        <div className={styles.parent}>
          <div className={styles.child} style={{ '--blurLeft': `${blurLeft || '-20px'}` }}>
            Redacted
          </div>
        </div>
      </Wrapper>
    </CTATooltip>
  );
};

export default RedactedDataPoint;
